/* eslint-disable standard/computed-property-even-spacing */
import maNavbarCategory from '@/components/navbarCategories'
import maButton from '@/components/button-blue'
import maDamagedPiece from './components/damagedPiece'
import maMultidamageForm from './components/multidamageForm'
import maMultidamagePcForm from './components/multidamagePcForm'
import maMultidamageCameraForm from './components/multidamageCameraForm'
import maMultidamagePhotoclaimForm from './components/multidamagePhotoclaimForm'
import maPhotoclaimForm from './components/photoclaimForm'
import maCameraForm from './components/cameraForm'
import maOverallCamera from './components/overallCamera'
import maCalculateSurfaceModal from './components/calculateSurfaceModal'
import maNavbarStepper from '@/components/navbarStepper'
import userFlowMixin from '@/modules/User/mixins/userFlowMixin'
import { apiGetForm } from '@/modules/Damage/services/menus'
import maSpinner from '@/components/spinner'
import flowMixin from '@/modules/Flow/mixins/flowMixin'
import { prepareErrorForSentry } from '@/utils/errorHandling'

// store module
import warrantyModule from '@/store/modules/warranty'

// utils
import { cloneDeep } from 'lodash'
import generateUniqueId from '@/utils/generateUniqueId'

// constants
import { INTERIOR_PROPERTY, MULTIDAMAGE } from '@/constants'

// api
import {
  apiPatchMultiDamages,
  apiPatchStayDamage,
  apiPostImage,
  sendPhotoclaimDamages
} from '@/modules/Damage/services/damages'

// import event Bus
import maEventBus from '@/components/eventbus/index.js'

// Vuex
import { mapState, mapMutations } from 'vuex'

// types
import { USER_MODULE_NAME } from '@/modules/User/store/types'
import {
  WARRANTY_MODULE_NAME,
  WARRANTY_CLEAR_FORMS,
  WARRANTY_CLEAR_REPORT,
  WARRANTY_CLEAR_REPORT_BY_CATEGORY,
  WARRANTY_CLEAR_REPORT_MURS,
  WARRANTY_CLEAR_SELECTED_DAMAGED_PARTS,
  WARRANTY_UPDATE_MULTIDAMAGE
} from '@/store/types'

const TYPES_BANNED = ['SOL', 'NETTOYAGE']
const TYPE_DAMAGE = 'TYPE_MATERIEL'

export default {
  name: 'multidamageList',
  mixins: [flowMixin, userFlowMixin],

  data() {
    return {
      loading: false,
      multidamagePieces: [],
      selectedDamageReport: {
        ASSETS: INTERIOR_PROPERTY,
        propertyType: this.$route.params.propertyType,
        PIECE: null
      },
      selectedDamagedPart: null,
      selectedAllDamagedParts: null,
      selectedPieceId: null,
      selectedPieceSurface: null,
      selectedDamageIndex: null,
      btnAddAllDamagesIsDisabled: true,
      isExpanded: false,
      surfaceModalIsOpen: false,
      isEditingPhotoclaim: false,
      materialOptions: [],
      someTypeBanned: false,
      selectedDamagedPhotos: null,
      selectedCameraPhotos: null,
      selectedOverallPhotos: null,
      selectedDamagesDetected: null,
      selectedDamageDetectedIndex: null,
      currentPiece: 0
    }
  },
  components: {
    maNavbarCategory,
    maDamagedPiece,
    maMultidamageForm,
    maMultidamagePcForm,
    maPhotoclaimForm,
    maCalculateSurfaceModal,
    maButton,
    maCameraForm,
    maMultidamageCameraForm,
    maOverallCamera,
    maMultidamagePhotoclaimForm,
    maSpinner,
    maNavbarStepper
  },
  computed: {
    ...mapState(WARRANTY_MODULE_NAME, {
      stateWarrantySinisterId: 'sinisterId',
      stateWarrantyId: 'warrantyId',
      stateIsMultidamage: 'isMultidamage',
      stateMultidamage: 'multidamage',
      stateWarrantyPropertyType: 'propertyType',
      stateWarrantySecondaryId: 'secondaryId',
      stateWarrantyZipCode: 'zipCode',
      stateWarrantyCoordinates: 'coordinates',
      stateWarrantyMoreThanTwoYears: 'moreThanTwoYears',
      stateWarrantyResidentType: 'residentType',
      stateWarrantyDamagedItem: 'damagedItem',
      stateWarrantyCategoryId: 'categoryId',
      stateWarrantySubtypeId: 'subtypeId',
      stateWarrantyDamageTypeLiteral: 'damageTypeLiteral',
      stateWarrantyCounterMurs: 'counterMurs'
    }),
    ...mapState(USER_MODULE_NAME, {
      stateUserId: 'userId',
      stateUserType: 'userType'
    }),

    isPhotoclaimFlow() {
      return this.getUserFlow === 'photoclaim' && !this.someTypeBanned
    },
    isPhotoclaim() {
      return this.getUserFlow === 'photoclaim'
    },
    flowName() {
      return this.getUserFlow
    },
    getFlowName() {
      if (this.isPhotoclaimUser) return this.getUserFlow
    },
    /**
         * Sets the damageType title based on the stateWarrantyDamageTypeLiteral if exists,
         * else it gets it from the local storage
         */
    titleNavBar() {
      const titleLocalStorage = localStorage.getItem('damageTypeLiteral')
      return this.stateWarrantyDamageTypeLiteral
        ? String(this.stateWarrantyDamageTypeLiteral)
        : titleLocalStorage
    },

    isMultidamage() {
      return this.stateIsMultidamage
    },

    sinisterId() {
      return String(this.stateWarrantySinisterId) || sessionStorage.getItem('sinId')
    },
    warrantyId() {
      return String(this.stateWarrantyId) || sessionStorage.getItem('formId')
    },
    propertyType() {
      return this.stateWarrantyPropertyType || this.$route.params.propertyType
    },
    getBtnType() {
      return this.loading ? 'spinnerBtn' : 'functionalBtn'
    }
  },

  methods: {
    ...mapMutations(WARRANTY_MODULE_NAME, {
      mutWarrantyClearForms: WARRANTY_CLEAR_FORMS,
      mutWarrantyClearReport: WARRANTY_CLEAR_REPORT,
      mutWarrantyClearReportMurs: WARRANTY_CLEAR_REPORT_MURS,
      mutWarrantyClearReportByCategory: WARRANTY_CLEAR_REPORT_BY_CATEGORY,
      mutWarrantyClearSelectedDamagedParts: WARRANTY_CLEAR_SELECTED_DAMAGED_PARTS,
      mutWarrantyUpdateMultidamage: WARRANTY_UPDATE_MULTIDAMAGE
    }),

    checkFormValid() {
      window.scrollTo(0, 0)
      let disable = false
      this.multidamagePieces.forEach((pieceType) => {
        pieceType.pieces.forEach((piece) => {
          if (!piece.pieceSurface) disable = true
          piece.damagedParts.forEach((damagedPart) => {
            if (!damagedPart.partDamages) disable = true
            if (
              damagedPart.partDamages &&
                            damagedPart.partDamages.length === 0
            ) {
              disable = true
            }
          })
        })
      })
      this.btnAddAllDamagesIsDisabled = disable
    },

    updateMultidamageState() {
      const multiDamage = {
        propertyType: this.propertyType,
        assets: INTERIOR_PROPERTY,
        damages: this.multidamagePieces
      }

      this.mutWarrantyUpdateMultidamage(multiDamage)
    },

    /**
         * Pushes the params for the damages-view route
         */
    routeToPartsView() {
      this.$router
        .push({
          name: 'damaged-parts',
          params: {
            propertyType: this.propertyType,
            damageType: INTERIOR_PROPERTY,
            damagedItem: MULTIDAMAGE
          }
        })
        .catch((e) => {})
    },

    /**
         * Pushes the params for the damages-view route
         */
    routeToDamagesView() {
      this.$router
        .push({
          name: 'damages-view'
        })
        .catch((e) => {})
    },

    /**
         * Clears all state properties
         */
    clearState() {
      this.mutWarrantyClearForms()
      this.mutWarrantyClearReport()
      this.mutWarrantyClearReportByCategory()
      this.mutWarrantyClearReportMurs()
      this.mutWarrantyClearSelectedDamagedParts()
    },

    /**
         * Clear selected report
         */
    clearSelectedReport() {
      this.selectedDamageReport.PIECE = null
      this.selectedDamagedPart = null
      this.selectedAllDamagedParts = null
      this.selectedPieceId = null
      this.selectedPieceSurface = null
      this.selectedDamageIndex = null
      this.selectedDamagedPhotos = null
      this.selectedDamagesDetected = null
    },

    /**
         * Trigger go to damagesView
         */
    handleClickPrevRoute() {
      window.removeEventListener('popstate', this.handleClickPrevRoute)
      this.clearState()
      this.updateMultidamageState()
      this.routeToPartsView()
    },

    /**
         * Remove damaged part
         */
    handleOnDeleteDamagedPart(pieceType, pieceId, partKey) {
      const pieces = this.multidamagePieces.find(
        (type) => type.damageKey === pieceType
      )
      const piece = pieces.pieces.find((piece) => piece.pieceId === pieceId)

      if (
        this.multidamagePieces.length === 1 &&
                piece.damagedParts.length === 1
      ) {
        this.clearState()
        this.routeToDamagesView()
        return
      }
      if (piece.damagedParts.length === 1) {
        if (pieces.pieces.length === 1) {
          this.multidamagePieces = this.multidamagePieces.filter(
            (type) => type.damageKey !== pieceType
          )
        } else {
          pieces.pieces = pieces.pieces.filter((p) => p.pieceId !== pieceId)
        }
      } else {
        piece.damagedParts = piece.damagedParts.filter(
          (part) => part.key !== partKey
        )
      }

      piece.id = generateUniqueId()
      this.checkFormValid()
    },

    /**
         * Remove damage
         */
    handleOnDeleteDamage(pieceType, pieceId, event) {
      const pieces = this.multidamagePieces.find(
        (type) => type.damageKey === pieceType
      ).pieces
      const piece = pieces.find((piece) => piece.pieceId === pieceId)
      const partDamages = piece.damagedParts.find(
        (part) => part.key === event.partKey
      ).partDamages

      partDamages.splice(event.damageIndex, 1)
      piece.id = generateUniqueId()
      this.checkFormValid()
    },

    /**
         * Remove damage
         */
    handleOnDeletePiece(pieceType, pieceId, event) {
      const damagePiece = this.multidamagePieces.find(
        (type) => type.damageKey === pieceType
      )
      const pieceIndex = damagePiece.pieces.findIndex(
        (piece) => piece.pieceId === pieceId
      )

      damagePiece.pieces.splice(pieceIndex, 1)

      if (damagePiece.pieces.length === 0) {
        const damagePieceIndex = this.multidamagePieces.indexOf(damagePiece)
        this.multidamagePieces.splice(damagePieceIndex, 1)
      }

      if (this.multidamagePieces.length === 0) {
        this.routeToDamagesView()
      }
    },

    /**
         * Edit damage
         */
    handleOnEditDamage(pieceType, pieceSurface, pieceId, event) {
      const pieces = this.multidamagePieces.find(
        (type) => type.damageKey === pieceType
      ).pieces
      const piece = pieces.find((piece) => piece.pieceId === pieceId)
      const damagedPart = piece.damagedParts.find(
        (part) => part.key === event.partKey
      )

      this.selectedDamageReport.PIECE = pieceType
      this.selectedDamagedPart = cloneDeep(damagedPart)
      this.selectedPieceId = pieceId
      this.selectedPieceSurface = pieceSurface
      this.selectedDamageIndex = event.damageIndex

      setTimeout(() => {
        this.$refs.multidamageForm.showModal()
      })
    },
    handleOnEditDamageCamara(pieceType, pieceSurface, pieceId, event) {
      const pieces = this.multidamagePieces.find(
        (type) => type.damageKey === pieceType
      ).pieces
      const piece = pieces.find((piece) => piece.pieceId === pieceId)
      const damagedPart = piece.damagedParts.find(
        (part) => part.key === event.partKey
      )

      this.selectedDamageReport.PIECE = pieceType
      this.selectedDamagedPart = cloneDeep(damagedPart)
      this.selectedPieceId = pieceId
      this.selectedPieceSurface = pieceSurface
      this.selectedDamageIndex = event.damageIndex

      setTimeout(() => {
        this.$refs.multidamageForm.showModal()
      })
    },
    /**
         * Open the modal with the form corresponding to the damage
         */
    handleOnShowModal(pieceType, pieceSurface, pieceId, damagedPart) {
      this.mutWarrantyClearForms()

      // Set multidamageForm component props
      this.selectedDamageReport.PIECE = pieceType
      this.selectedDamagedPart = cloneDeep(damagedPart)
      this.selectedPieceId = pieceId
      this.selectedPieceSurface = pieceSurface
      this.selectedDamageIndex = null

      setTimeout(() => {
        this.$refs.multidamageForm.showModal()
      })
    },

    handleOnShowModalCamera(pieceType, pieceSurface, pieceId, damagedPart) {
      this.mutWarrantyClearForms()

      // Set multidamageForm component props
      this.selectedDamageReport.PIECE = pieceType
      this.selectedDamagedPart = cloneDeep(damagedPart)
      this.selectedPieceId = pieceId
      this.selectedPieceSurface = pieceSurface
      this.selectedDamageIndex = null

      setTimeout(() => {
        this.$refs.cameraForm.showModal()
      })
    },

    handleOnShowModalOverallCamera(
      pieceType,
      pieceSurface,
      pieceId,
      damagedPart
    ) {
      this.mutWarrantyClearForms()

      // Set multidamageForm component props
      this.selectedDamageReport.PIECE = pieceType
      this.selectedDamagedPart = cloneDeep(damagedPart)
      this.selectedPieceId = pieceId
      this.selectedPieceSurface = pieceSurface
      this.selectedDamageIndex = null

      setTimeout(() => {
        this.$refs.overallCamera.showModal()
      })
    },

    handleOnAddMoreDamage(pieceType, pieceSurface, pieceId, damagedPart) {
      // console.log(damagedPart.partDamages)

      this.mutWarrantyClearForms()

      // Set multidamageForm component props
      this.selectedDamageReport.PIECE = pieceType
      this.selectedDamagedPart = cloneDeep(damagedPart)
      this.selectedPieceId = pieceId
      this.selectedPieceSurface = pieceSurface
      this.selectedDamageIndex = null

      setTimeout(() => {
        this.$refs.multidamageCameraForm.showModal()
      })
    },

    handlePhotoclaimModal(
      damagedLiteral,
      pieceType,
      pieceSurface,
      pieceId,
      damagedParts
    ) {
      this.mutWarrantyClearForms()
      // Set multidamageForm component props
      this.selectedDamageReport.PIECE = pieceType
      this.selectedAllDamagedParts = cloneDeep(damagedParts)
      this.selectedPieceId = pieceId
      this.selectedPieceSurface = pieceSurface
      this.selectedDamageIndex = null

      setTimeout(() => {
        this.$refs.photoclaimForm.showModal(damagedLiteral)
      })
    },

    /**
         *
         */
    handleOnSurfaceChange(pieceType, pieceId, value) {
      const pieces = this.multidamagePieces.find(
        (type) => type.damageKey === pieceType
      ).pieces
      const piece = pieces.find((piece) => piece.pieceId === pieceId)

      piece.pieceSurface = value

      this.updatePartsSurfaces(piece)
      this.checkFormValid()
    },

    handleSurfaceModal(modalIsOpen, damageKey, pieceId) {
      if (modalIsOpen) {
        this.surfaceModalIsOpen = true
        this.selectedDamagedPart = damageKey
        this.selectedPieceId = pieceId
      } else {
        this.surfaceModalIsOpen = false
        this.selectedDamagedPart = null
        this.selectedPieceId = null
      }
    },

    calculateSurface({ width, length }) {
      const footInSquareMeters = 0.8
      const widthInSquareMeters = width * footInSquareMeters
      const lengthInSquareMeters = length * footInSquareMeters
      const areaInSquareMeters = widthInSquareMeters * lengthInSquareMeters
      return areaInSquareMeters.toFixed(2)
    },

    handleCalculateSurface(value) {
      this.handleOnSurfaceChange(
        this.selectedDamagedPart,
        this.selectedPieceId,
        this.calculateSurface(value, value)
      )
      this.surfaceModalIsOpen = false
      this.selectedDamagedPart = null
      this.selectedPieceId = null
    },

    /**
         * Get new surfaceInput value by piece and update all its parts
         */
    updatePartsSurfaces(piece) {
      piece.damagedParts.forEach((damagedPart) => {
        if (damagedPart.partDamages) {
          damagedPart.partDamages.forEach((damage) => {
            if (damage.damages['ROOM_SURFACE'] != null) {
              damage.damages['ROOM_SURFACE'] = piece.pieceSurface
            }
          })
        }
      })
      maEventBus.$emit('accordion:resize')
    },

    async handleOverallStepConfirmed(pieceType, pieceId) {
      this.currentPiece++

      const curr = this.$refs.pieces.find(
        (piece) => piece.pieceRefIndex === this.currentPiece
      )
      if (curr) curr.expandPiece()

      const { damages, commonDamageBody, commonFormInfo } =
            this.handleOnAddMultidamageNewCamera()

      const typeIndex = this.multidamagePieces.findIndex(
        (type) => type.damageKey === pieceType
      )

      const pieceIndex = this.multidamagePieces[typeIndex].pieces.findIndex(
        (piece) => piece.pieceId === pieceId
      )

      const damageParts =
                this.multidamagePieces[typeIndex].pieces[pieceIndex].damagedParts

      for (const damagedPart of damageParts) {
        for (const damage of damagedPart.partDamages) {
          const support =
                        damagedPart.key.indexOf('MUR') !== -1
                          ? `${damage.damages.QUANTITY}MUR`
                          : damagedPart.key
          if (damagedPart.key === 'NETTOYAGE') {
            damage.damages.UNITS = '1'
          }
          const images = await this.parsedImages(damage.images)
          const damageReport = {
            ...commonDamageBody,
            piece_id: pieceId,
            images: images,
            form_info: {
              ...commonFormInfo,
              PIECE: pieceType,
              SUPPORT: support,
              ...damage.damages,
              asset_damages: damage.asset_damages
            }
          }

          damages.items.push(damageReport)
        }
      }

      await apiPatchMultiDamages(damages)
        .then(async() => {
          await this.sendStayDamage(damages)
          this.selectedOverallPhotos = null
          const piece = this.multidamagePieces[typeIndex].pieces[pieceIndex]
          piece.confirmedMultidamage = true
          this.multidamagePieces[typeIndex].expanded = false

          this.$set(
            this.multidamagePieces[typeIndex].pieces,
            pieceIndex,
            cloneDeep(piece)
          )

          const finished = this.multidamagePieces.every((multiDamagePiece) => {
            return multiDamagePiece.pieces.every(
              (piece) => piece.confirmedMultidamage
            )
          })

          // console.log(finished)

          if (finished) {
            this.clearState()
            this.mutWarrantyUpdateMultidamage({})
            this.routeToDamagesView()
          }
        })
        .catch((error) => {
          const context = {
            component: 'multiDamageList',
            method: 'handleOverallStepConfirmed',
            route: this.$route.path
          }

          const tags = prepareErrorForSentry(error, context)

          this.sendSentryError(
            `Error submitting multidamage report: ${error.message || 'Unknown error'}`,
            error.response && error.response.status >= 500 ? 'error' : 'warning',
            tags,
            this.getSinisterId,
            'handleOverallStepConfirmed'
          )

          const errs = [400, 500, 404]
          const errCode =
                        errs.find(
                          (errCode) => error.response && error.response.status === errCode
                        ) || 404
          const messageNotification = this.$t(
            `notifications.error.${errCode}.title`
          )
          window.scrollTo(0, 0)
          this.throwNotification(messageNotification, messageNotification, 'KO')
        })
        .finally(() => {
          this.loading = false
        })
    },

    /**
         * Update part damages
         */
    handleOnPartDamageAdded({ pieceType, pieceId, damagedPart }) {
      if (this.isEditingPhotoclaim) {
        const partAdded = damagedPart.partDamages.pop()

        if (this.selectedDamageDetectedIndex !== null) {
          this.selectedDamagesDetected.splice(
            this.selectedDamageDetectedIndex,
            1,
            partAdded
          )
        } else {
          this.selectedDamagesDetected.push(partAdded)
        }
        this.damageIndex = null
        this.isEditingPhotoclaim = false
        this.selectedDamageDetectedIndex = null
        this.selectedDamageIndex = null
        return
      }

      const typeIndex = this.multidamagePieces.findIndex(
        (type) => type.damageKey === pieceType
      )
      const pieceIndex = this.multidamagePieces[typeIndex].pieces.findIndex(
        (piece) => piece.pieceId === pieceId
      )
      const partIndex = this.multidamagePieces[typeIndex].pieces[
        pieceIndex
      ].damagedParts.findIndex((part) => part.key === damagedPart.key)

      this.multidamagePieces[typeIndex].pieces[pieceIndex].damagedParts[
        partIndex
      ] = cloneDeep(damagedPart)

      this.multidamagePieces[typeIndex].id = generateUniqueId()
      this.clearSelectedReport()
      this.checkFormValid()
    },

    handleOnPartDamageAddedFromPc(payload) {
      const typeIndex = this.multidamagePieces.findIndex(
        (type) => type.damageKey === payload.pieceType
      )
      const pieceIndex = this.multidamagePieces[typeIndex].pieces.findIndex(
        (piece) => piece.pieceId === payload.pieceId
      )

      const partIndex = this.multidamagePieces[typeIndex].pieces[
        pieceIndex
      ].photoclaimDamagedParts.findIndex(
        (damagedPart) => damagedPart.key === payload.damagedPart.key
      )

      const spacePhotos =
                this.multidamagePieces[typeIndex].pieces[pieceIndex].spacePhotos

      const photoclaimPartDamaged =
                this.multidamagePieces[typeIndex].pieces[pieceIndex]
                  .photoclaimDamagedParts[partIndex]

      let partDamage = payload.damagedPart.partDamages[payload.damageIndex]

      partDamage = {
        images: [...spacePhotos],
        damages: { ...partDamage.damages },
        description: 'Not Found',
        literal: partDamage.literal,
        damageConfirmed: true,
        asset_damages: partDamage.asset_damages
      }

      if (this.selectedDamageIndex === null) {
        photoclaimPartDamaged.partDamages.push(partDamage)
      } else {
        photoclaimPartDamaged.partDamages[this.selectedDamageIndex] = partDamage
      }

      this.$set(
        this.multidamagePieces[typeIndex].pieces[pieceIndex]
          .photoclaimDamagedParts,
        partIndex,
        cloneDeep(photoclaimPartDamaged)
      )

      maEventBus.$emit('accordion:resize')

      this.clearSelectedReport()
    },

    async handleConfirmPhotoclaimDamages(
      pieceType,
      damagedPiece,
      pcDamagedPart
    ) {
      const damages = {
        sinister_id: this.stateWarrantySinisterId || sessionStorage.getItem('sinId'),
        items: []
      }
      const commonDamageBody = {
        category: this.stateWarrantyCategoryId || sessionStorage.getItem('formId'),
        subcategory: this.stateWarrantySubtypeId ||
                    localStorage.getItem('warranty_subtype_id')
      }
      const commonFormInfo = {
        propertyType: this.stateMultidamage.propertyType,
        ASSETS: this.stateMultidamage.assets
      }

      damagedPiece.photoclaimDamagedParts.forEach((damagedPart) => {
        if (damagedPart.key !== pcDamagedPart.key) return

        for (const damage of damagedPart.partDamages) {
          const support =
                        damagedPart.key.indexOf('MUR') !== -1
                          ? `${damage.damages.QUANTITY}MUR`
                          : damagedPart.key
          if (damagedPart.key === 'NETTOYAGE') {
            damage.damages.UNITS = '1'
          }
          const damageReport = {
            ...commonDamageBody,
            piece_id: damagedPiece.pieceId,
            images: damage.images,
            form_info: {
              ...commonFormInfo,
              PIECE: pieceType,
              SUPPORT: support,
              ...damage.damages,
              asset_damages: damage.asset_damages
            }
          }

          damages.items.push(damageReport)
        }
      })

      await apiPatchMultiDamages(damages)
        .then(() => {
          const typeIndex = this.multidamagePieces.findIndex(
            (type) => type.damageKey === pieceType
          )
          const pieceIndex = this.multidamagePieces[typeIndex].pieces.findIndex(
            (piece) => piece.pieceId === damagedPiece.pieceId
          )

          const partIndex = this.multidamagePieces[typeIndex].pieces[
            pieceIndex
          ].photoclaimDamagedParts.findIndex(
            (damagedPart) => damagedPart.key === pcDamagedPart.key
          )

          const partDamaged =
                        this.multidamagePieces[typeIndex].pieces[pieceIndex]
                          .photoclaimDamagedParts[partIndex]

          partDamaged.partDamages.forEach(
            (damage) => (damage.damageConfirmed = true)
          )

          partDamaged.damagesSended = true

          this.$set(
            this.multidamagePieces[typeIndex].pieces[pieceIndex]
              .photoclaimDamagedParts,
            partIndex,
            cloneDeep(partDamaged)
          )

          // this.updateMultidamageState()

          const finished = this.multidamagePieces[typeIndex].pieces[
            pieceIndex
          ].photoclaimDamagedParts.every((pcPart) => pcPart.damagesSended)

          maEventBus.$emit('accordion:resize')

          if (finished) {
            this.clearState()
            this.mutWarrantyUpdateMultidamage({})
            this.routeToDamagesView()
          }
        })
        .catch((error) => {
          const context = {
            component: 'multiDamageList',
            method: 'handleConfirmPhotoclaimDamages',
            route: this.$route.path
          }

          const tags = prepareErrorForSentry(error, context)

          this.sendSentryError(
            `Error confirming photoclaim damages: ${error.message || 'Unknown error'}`,
            error.response && error.response.status >= 500 ? 'error' : 'warning',
            { ...tags, damageData: damages },
            this.getSinisterId,
            'handleConfirmPhotoclaimDamages'
          )

          const errs = [400, 500, 404]
          const errCode =
                        errs.find((errCode) => error.response.status === errCode) || 404
          const messageNotification = this.$t(
            `notifications.error.${errCode}.title`
          )
          window.scrollTo(0, 0)
          this.throwNotification(messageNotification, messageNotification, 'KO')
        })
        .finally(() => {
          this.loading = false
        })
    },

    handleOnAddPhotoclaimDamage({ damagedPiece, damagedKey, damagePart }) {
      const pieces = this.multidamagePieces.find(
        (type) => type.damageKey === damagedKey
      ).pieces

      const piece = pieces.find(
        (piece) => piece.pieceId === damagedPiece.pieceId
      )

      const damagedPart = piece.photoclaimDamagedParts.find(
        (part) => part.key === damagePart.key
      )

      this.selectedDamageReport.PIECE = damagedKey
      this.selectedDamagedPart = cloneDeep(damagedPart)
      this.selectedPieceId = damagedPiece.pieceId
      this.selectedPieceSurface = damagedPiece.pieceSurface
      this.selectedDamageIndex = null

      setTimeout(() => {
        this.$refs.multidamagePcForm.showModal()
      })
    },

    handleOnEditPhotoclaimDamage({
      damagedPiece,
      damagedKey,
      damagePart,
      damageIndex
    }) {
      const pieces = this.multidamagePieces.find(
        (type) => type.damageKey === damagedKey
      ).pieces

      const piece = pieces.find(
        (piece) => piece.pieceId === damagedPiece.pieceId
      )

      const damagedPart = piece.photoclaimDamagedParts.find(
        (part) => part.key === damagePart.key
      )

      this.selectedDamageReport.PIECE = damagedKey
      this.selectedDamagedPart = cloneDeep(damagedPart)
      this.selectedPieceId = damagedPiece.pieceId
      this.selectedPieceSurface = damagedPiece.pieceSurface
      this.selectedDamageIndex = damageIndex

      setTimeout(() => {
        this.$refs.multidamagePcForm.showModal()
      })
    },
    handleCameraPhotos(photos) {
      this.selectedDamagedPhotos = photos.images
      setTimeout(() => {
        this.$refs.multidamageCameraForm.showModal()
      })
    },

    handleEditOption(damageIndex) {
      const damage = this.selectedDamagesDetected[damageIndex]
      if (this.selectedDamagedPart.partDamages) {
        this.selectedDamagedPart.partDamages.push(damage)
      } else {
        this.selectedDamagedPart.partDamages = [damage]
      }
      this.selectedDamageDetectedIndex = damageIndex
      this.selectedDamageIndex = this.selectedDamagedPart.partDamages.length - 1
      this.handleOnPartDamagePhotoclaimAdd()
    },

    handleDeleteOption(damageIndex) {
      this.selectedDamagesDetected.splice(damageIndex, 1)
    },

    prepareImagesBody(photos) {
      const imagesBody = []

      for (let [index, imgBase64] of photos.entries()) {
        const [, ext] = imgBase64.split(';')[0].split('/')
        const imageContent = imgBase64.replace(
          /data:[A-z]*\/[A-z]*;base64,/,
          ''
        )

        let imgBody = {
          imageName: `${index}_${new Date().getTime()}.${ext}`,
          imageType: 'photoClaimFlow',
          imageContent: imageContent
        }
        imagesBody.push(imgBody)
      }

      return imagesBody
    },

    async uploadImages(images) {
      const damagePartsPromises = []

      const imgsBody = this.prepareImagesBody(images)

      for (const imgBody of imgsBody) {
        damagePartsPromises.push(apiPostImage(this.getSinisterId, imgBody))
      }
      try {
        return await Promise.all(damagePartsPromises)
      } catch (error) {
        const context = {
          component: 'multiDamageList',
          method: 'uploadImages',
          route: this.$route.path
        }

        const tags = prepareErrorForSentry(error, context)

        this.sendSentryError(
          `Error uploading images: ${error.message || 'Unknown error'}`,
          error.response && error.response.status >= 500 ? 'error' : 'warning',
          tags,
          this.getSinisterId,
          'uploadImages'
        )
      }
    },

    async sendPhotoclaimPhotos(damagesImages, damagedPartKey) {
      const photoclaimBody = []

      const part = {
        images: []
      }
      part.support = damagedPartKey

      for (const { imageURL }
        of [...damagesImages]) {
        part.images.push(imageURL)
      }
      photoclaimBody.push(part)

      return await sendPhotoclaimDamages(this.getSinisterId, photoclaimBody)
    },

    async buildDamagesFromPhotoclaim(photoClaimDamages, event) {
      if (!photoClaimDamages) return

      const {
        images,
        payload: { damageKey, pieceId, damagedPartKey }
      } = event

      const typeIndex = this.multidamagePieces.findIndex(
        (type) => type.damageKey === damageKey
      )
      const pieceIndex = this.multidamagePieces[typeIndex].pieces.findIndex(
        (piece) => piece.pieceId === pieceId
      )

      const damagePartsFound = []

      for (const damage of photoClaimDamages.photoclaimDamageDescriptionDTO) {
        if (!damage) continue

        const partDamage = {
          damages: {}
        }

        // Update murs
        if (damagedPartKey.indexOf('MUR') !== -1) {
          partDamage.damages.QUANTITY = this.stateWarrantyCounterMurs
        }

        partDamage.damages['ROOM_SURFACE'] =
                    this.multidamagePieces[typeIndex].pieces[pieceIndex].pieceSurface

        partDamage.damages = {
          ...partDamage.damages,
          ...damage.form_info
        }

        try {
          const { form } = await apiGetForm({
            ASSETS: INTERIOR_PROPERTY,
            propertyType: this.$route.params.propertyType,
            PIECE: damageKey,
            SUPPORT: damagedPartKey,
            ...damage.form_info
          },
          this.getWarrantyId
          )

          form.regions.forEach((region) => {
            region.inputs.forEach((input) => {
              if (input.name === TYPE_DAMAGE) {
                partDamage.type = input.name
                partDamage.value = damage.form_info[TYPE_DAMAGE]
                partDamage.literal = input.options.find(
                  (option) => option.key === damage.form_info[TYPE_DAMAGE]
                ).literal
              }
            })
          })

          const damagedPartPhotoclaim = {
            asset_damages: form.asset_damages,
            images: [...images],
            description: damage.description,
            ...partDamage
          }

          damagePartsFound.push(damagedPartPhotoclaim)
        } catch (error) {
          const context = {
            component: 'multiDamageList',
            method: 'buildDamagesFromPhotoclaim',
            route: this.$route.path
          }

          const tags = prepareErrorForSentry(error, context)

          this.sendSentryError(
            `Error getting damage form from photoclaim: ${error.message || 'Unknown error'}`,
            error.response && error.response.status >= 500 ? 'error' : 'warning',
            tags,
            this.getSinisterId,
            'buildDamagesFromPhotoclaim'
          )
        }
      }

      return damagePartsFound
    },

    handleOnPartDamagePhotoclaimAdd() {
      this.isEditingPhotoclaim = true
      setTimeout(() => {
        this.$refs.multidamageCameraForm.showModal()
      })
    },

    handleOnPartDamagePhotoclaimFinished() {
      const typeIndex = this.multidamagePieces.findIndex(
        (type) => type.damageKey === this.selectedDamageReport.PIECE
      )
      const pieceIndex = this.multidamagePieces[typeIndex].pieces.findIndex(
        (piece) => piece.pieceId === this.selectedPieceId
      )
      const partIndex = this.multidamagePieces[typeIndex].pieces[
        pieceIndex
      ].damagedParts.findIndex(
        (part) => part.key === this.selectedDamagedPart.key
      )

      const damagedPart =
                this.multidamagePieces[typeIndex].pieces[pieceIndex].damagedParts[
                  partIndex
                ]

      for (const damageBuilt of this.selectedDamagesDetected) {
        if (damagedPart.partDamages != null) {
          damagedPart.partDamages.push(damageBuilt)
        } else {
          damagedPart.partDamages = [damageBuilt]
        }
      }

      this.multidamagePieces[typeIndex].pieces[pieceIndex].damagedParts[
        partIndex
      ] = cloneDeep(damagedPart)

      this.multidamagePieces[typeIndex].id = generateUniqueId()
      this.clearSelectedReport()
      this.checkFormValid()
    },

    handleOnPartDamagePhotoclaimCanceled() {
      this.clearSelectedReport()
    },

    async handleCameraPhotosPhotoclaim(event) {
      this.loading = true

      try {
        const {
          images,
          payload: { damagedPartKey }
        } = event

        this.selectedDamagedPhotos = images

        const damagesImages = await this.uploadImages(images)

        const respPhotoclaim = await this.sendPhotoclaimPhotos(
          damagesImages,
          damagedPartKey
        )

        const photoClaimDamages = respPhotoclaim.find((photoClaimPart) => {
          return photoClaimPart.support === damagedPartKey
        })

        const partDamagesBuilt = await this.buildDamagesFromPhotoclaim(
          photoClaimDamages,
          event
        )

        if (partDamagesBuilt.length > 0) {
          this.selectedDamagesDetected = partDamagesBuilt
          this.$refs.multidamagePhotoclaimForm.showModal()
        } else {
          this.$refs.multidamageCameraForm.showModal()
        }
        this.loading = false
      } catch (err) {
        console.error(err)
        this.loading = false
      }
    },

    handleOverallPhotos(photo) {
      this.selectedOverallPhotos = photo.image
    },

    handleOnDeletePhotoclaimDamage(damageKey, payload) {
      const typeIndex = this.multidamagePieces.findIndex(
        (type) => type.damageKey === damageKey
      )
      const pieceIndex = this.multidamagePieces[typeIndex].pieces.findIndex(
        (piece) => piece.pieceId === payload.damagedPiece.pieceId
      )

      const partIndex = this.multidamagePieces[typeIndex].pieces[
        pieceIndex
      ].damagedParts.findIndex((part) => part.key === payload.damagePart.key)

      const photoclaimPartDamaged =
                this.multidamagePieces[typeIndex].pieces[pieceIndex]
                  .photoclaimDamagedParts[partIndex]

      photoclaimPartDamaged.partDamages.splice(payload.damageIndex, 1)

      this.$set(
        this.multidamagePieces[typeIndex].pieces[pieceIndex]
          .photoclaimDamagedParts,
        partIndex,
        cloneDeep(photoclaimPartDamaged)
      )
      maEventBus.$emit('accordion:resize')
    },

    async handleOnAllPartsDamageAdded(partsAddedObject) {
      const { damagedParts, pieceType, pieceId, spacePhotos } = partsAddedObject

      const typeIndex = this.multidamagePieces.findIndex(
        (type) => type.damageKey === pieceType
      )
      const pieceIndex = this.multidamagePieces[typeIndex].pieces.findIndex(
        (piece) => piece.pieceId === pieceId
      )

      this.multidamagePieces[typeIndex].pieces[pieceIndex].photosTaken = true
      this.multidamagePieces[typeIndex].pieces[pieceIndex].spacePhotos =
                spacePhotos
      this.multidamagePieces[typeIndex].pieces[
        pieceIndex
      ].photoclaimDamagedParts = damagedParts
      this.multidamagePieces[typeIndex].id = generateUniqueId()
      this.clearSelectedReport()
      this.checkFormValid()
    },

    async parsedImages(photos) {
      const sinisterId = this.stateWarrantySinisterId || sessionStorage.getItem('sinId')

      if (!photos || photos.length === 0) {
        return []
      }

      const photosParsed = photos.map((element, index) => {
        if (element.imageURL) {
          return element
        }

        const [, ext] = element.split(';')[0].split('/')
        const imageContent = element.replace(/data:[A-z]*\/[A-z]*;base64,/, '')

        return {
          imageName: `CameraFlow_${new Date().getTime() + index}.${ext}`,
          imageType: 'photoClaimFlow',
          imageContent: imageContent
        }
      })

      if (photosParsed.every(item => item.imageURL)) {
        return photosParsed
      }

      const damagePartsPromises = []

      for (const imgBody of photosParsed) {
        if (imgBody.imageURL) {
          damagePartsPromises.push(Promise.resolve(imgBody))
        } else {
          damagePartsPromises.push(apiPostImage(sinisterId, imgBody))
        }
      }
      try {
        const damagesImages = await Promise.all(damagePartsPromises)
        return damagesImages
      } catch (error) {
        const context = {
          component: 'multiDamageList',
          method: 'parsedImages',
          route: this.$route.path
        }

        const tags = prepareErrorForSentry(error, context)

        this.sendSentryError(
          `Error parsing and uploading images: ${error.message || 'Unknown error'}`,
          error.response && error.response.status >= 500 ? 'error' : 'warning',
          tags,
          this.getSinisterId,
          'parsedImages'
        )
      }
    },

    /**
         * Save all damages
         */
    handleOnAddMultidamageNewCamera() {
      window.removeEventListener('popstate', this.handleClickPrevRoute)
      this.loading = true

      let damages = {
        sinister_id: this.stateWarrantySinisterId || sessionStorage.getItem('sinId'),
        items: []
      }
      const commonDamageBody = {
        category: this.stateWarrantyCategoryId || sessionStorage.getItem('formId'),
        subcategory: this.stateWarrantySubtypeId ||
                    localStorage.getItem('warranty_subtype_id')
      }
      const commonFormInfo = {
        propertyType: this.stateMultidamage.propertyType,
        ASSETS: this.stateMultidamage.assets
      }

      return { damages, commonDamageBody, commonFormInfo }
    },

    async sendStayDamage(damages) {
      const damageItems = damages.items[0]
      const sinister_id = damages.sinister_id

      if (this.selectedOverallPhoto === undefined) {
        damageItems.images = []
      } else {
        damageItems.images = await this.parsedImages(this.selectedOverallPhotos)
      }

      const damageBody = { ...damageItems, sinister_id }

      await apiPatchStayDamage(damageBody)
        .catch((error) => {
          const context = {
            component: 'multiDamageList',
            method: 'sendStayDamage',
            route: this.$route.path
          }

          const tags = prepareErrorForSentry(error, context)

          this.sendSentryError(
            `Error sending stay damage: ${error.message || 'Unknown error'}`,
            error.response && error.response.status >= 500 ? 'error' : 'warning',
            { ...tags, damageData: damages },
            this.getSinisterId,
            'sendStayDamage'
          )

          const errs = [400, 500, 404]
          const errCode =
                        errs.find((errCode) => error.response.status === errCode) || 404
          const messageNotification = this.$t(
            `notifications.error.${errCode}.title`
          )
          window.scrollTo(0, 0)
          this.throwNotification(messageNotification, messageNotification, 'KO')
        })
        .finally(() => {
          this.loading = false
        })
    },
    async handleOnAddMultidamage() {
      this.loading = true
      const damages = {
        sinister_id: this.stateWarrantySinisterId || sessionStorage.getItem('sinId'),
        items: []
      }
      const commonDamageBody = {
        category: this.stateWarrantyCategoryId || sessionStorage.getItem('formId'),
        subcategory: this.stateWarrantySubtypeId ||
                    localStorage.getItem('warranty_subtype_id')
      }
      const commonFormInfo = {
        propertyType: this.stateMultidamage.propertyType,
        ASSETS: this.stateMultidamage.assets
      }

      for (const pieceType of this.multidamagePieces) {
        for (const piece of pieceType.pieces) {
          for (const damagedPart of piece.damagedParts) {
            for (const damage of damagedPart.partDamages) {
              const support =
                damagedPart.key.includes('MUR') ? `${damage.damages.QUANTITY}MUR` : damagedPart.key
              if (damagedPart.key === 'NETTOYAGE') {
                damage.damages.UNITS = '1'
              }

              const formatImages = await this.parsedImages(damage.images)

              const damageReport = {
                ...commonDamageBody,
                piece_id: piece.pieceId,
                images: formatImages,
                form_info: {
                  ...commonFormInfo,
                  PIECE: pieceType.damageKey,
                  SUPPORT: support,
                  ...damage.damages,
                  asset_damages: damage.asset_damages
                }
              }

              damages.items.push(damageReport)
            }
          }
        }
      }

      await apiPatchMultiDamages(damages)
        .then(() => {
          this.clearState()
          this.mutWarrantyUpdateMultidamage({})
          this.routeToDamagesView()
        })
        .catch((error) => {
          const context = {
            component: 'multiDamageList',
            method: 'handleOnAddMultidamage',
            route: this.$route.path
          }

          const tags = prepareErrorForSentry(error, context)

          this.sendSentryError(
            `Error adding multidamage: ${error.message || 'Unknown error'}`,
            error.response && error.response.status >= 500 ? 'error' : 'warning',
            { ...tags, damageData: damages },
            this.getSinisterId,
            'handleOnAddMultidamage'
          )

          const errs = [400, 500, 404]
          const errCode =
                        errs.find((errCode) => error.response.status === errCode) || 404
          const messageNotification = this.$t(
            `notifications.error.${errCode}.title`
          )
          window.scrollTo(0, 0)
          this.throwNotification(messageNotification, messageNotification, 'KO')
        })
        .finally(() => {
          this.loading = false
        })
    }
  },

  async mounted() {
    // Notify Vue App of the current active element in screen
    this.notifyAppOfChanges(this)
    this.mutWarrantyClearForms()
    window.scrollTo(0, 0)

    if (this.isMultidamage) {
      this.multidamagePieces = cloneDeep(this.stateMultidamage).damages

      let index = 0
      this.multidamagePieces.forEach((pieceType) => {
        pieceType.pieces.forEach((piece) => {
          if (piece.pieceSurface == null) piece.pieceSurface = 0
          if (piece.confirmedMultidamage == null) { piece.confirmedMultidamage = false }
          if (piece.pieceRefIndex == null) piece.pieceRefIndex = index++
        })
      })
      this.someTypeBanned = this.multidamagePieces.some((damagePiece) =>
        damagePiece.pieces.some((piece) =>
          piece.damagedParts.some((part) => TYPES_BANNED.includes(part.key))
        )
      )
      this.checkFormValid()
    } else {
      this.clearState()
      this.routeToDamagesView()
    }
  },

  beforeCreate: function() {
    if (!(WARRANTY_MODULE_NAME in this.$store.state)) {
      this.$store.registerModule(WARRANTY_MODULE_NAME, warrantyModule)
    }
  }
}
